import { SchemaExplorerUIOptions } from '../../../warehouse-management/schema-explorer/interfaces/schemaExplorer';
import { ActivationStrings } from '../strings';


export const CREATE_ACTIVATION_CACHE_KEY = 'activation.general.create-activation.wizard';
export const ACTIVATION_SYNC_BEHAVIOUR_TOUR_SHOWN = 'activation.syncBehaviour.tourShown';

export const ACTIVATION_SYNC_BEHAVIOUR_DOC_LINK = '/activate/activate-concepts/sync-behavior/';

export const SYNC_HISTORY_SHIMMER_DIMENSIONS = [
  [ '120px', '80px', '70px', '80px', '90px', '80px', '100px', '0px' ],
  [ '140px', '100px', '60px', '90px', '110px', '100px', '110px', '0px' ],
  [ '130px', '90px', '90px', '80px', '100px', '90px', '80px', '0px' ]
];

export const SCHEMA_EXPLORER_ACTIVATION_UI_OPTIONS: SchemaExplorerUIOptions = {
  searchAreaBorder: false,
  showFieldTypeIcon: true,
  allowTableCreation: false,
  showTableMenuOption: false,
  showRelationsLineage: false,
  reauthoriseWarningBody: ActivationStrings.reauthoriseWarningBody
};

export const SYNC_HISTORY_STATUS_FILTER_KEY = 'status';
export const SYNC_HISTORY_PAGE_SIZE = 30;

export const DUPLICATE_COLUMN_ERROR_MESSAGE = 'Duplicate columns found! Your current query result has duplicate columns, ' +
  'this will create a problem in mapping. Please edit your query.';
